const routes = {
  home: "/",
  AmbienteDev: "/AmbienteDev",
  EspelhoProducao: "/EspelhoProducao",
  EspelhoProducaoImpressao: "/EspelhoProducao/Imprimir",
  RegistroBiometrico: "/RegistroBiometrico",
  RegistroBiometricoImpressao: "/RegistroBiometrico/Imprimir",
  PrevisaoProducao: "/PrevisaoProducao",
  PrevisaoProducaoImpressao: "/PrevisaoProducao/Imprimir",
  ExtratoRepasseExterno: "/ExtratoRepasseExterno",
  ExtratoRepasseExternoImpressao: "/ExtratoRepasseExterno/Imprimir",
  ExtratoRepasseExternoV2: "/ExtratoRepasseExternoV2",
  ExtratoRepasseExternoV2Impressao: "/ExtratoRepasseExternoV2/Imprimir",
  ExtratoRepasse: "/ExtratoRepasse",
  DemonstrativoFinanceiro: "/DemonstrativoFinanceiro",
  DemonstrativoFinanceiroImpressao: "/DemonstrativoFinanceiro/Imprimir",
  ExtratoRepasseImpressao: "/ExtratoRepasse/Imprimir",
  IR: "/IR",
  IRImpressao: "/IR/Imprimir",
  RecuperacaoSenha: "/RecuperacaoSenha",
  PreCadastro: "/PreCadastro",
  RecuperacaoSenhaImpressao: "/RecuperacaoSenha/Imprimir",
  Procedimentos: "/Procedimentos",
  Documentos: "/Documentos",
};

export default routes;
